import showJSDConfirmPayDialog from '@/components/jsdConfirm/jsdConfirmPayDialog';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  apiCreateFirstActivityOrder,
  apiGetFirstActivityList,
  apiGetPayConfigReduction,
  apiGetPayTypeConfigList,
  apiGetWeChatSignature,
  apiPayFirstActivityOrder,
} from '../../api';
import AppBar from '../../components/appBar';
import NoData from '../../components/noData';
import Page from '../../components/page';
import main from '../../main';
import { PayType } from '../../utils/dict';
import showPayPage from '../../utils/pay';
import { LoadingMask, modelParsePrice, showBottom, showConfirm, showToast } from '../../utils/utils';
import ActivityPaySheet from './activityPaySheet';

export default function ActivityPage() {
  const navigate = useNavigate();
  const [activity, setActivity] = useState<ChargeFirst>();

  const [reduction, setReduction] = useState<any>({});
  const [payConfigList, setPayConfigList] = useState<PayTypeConfig[]>([]);
  const [payType, setPayType] = useState<string>();
  const [wxReady, setWxReady] = useState(false);
  useEffect(() => {
    loadActivity();
    loadPayConfigReduction();
    loadPayConfigList();
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener(
          'WeixinJSBridgeReady',
          () => {
            setWxReady(true);
          },
          false
        );
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => {
          setWxReady(true);
        });
      }
    } else {
      setWxReady(true);
    }
    wxConfig();
  }, []); // eslint-disable-line

  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;

    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'],
      });
    }
  }

  /**
   * 获取支付配置列表
   */
  async function loadPayConfigList() {
    try {
      let res = await apiGetPayTypeConfigList();
      let data = res.data;
      if (data.code === 200) {
        let list: PayTypeConfig[] = data.data ?? [];
        list = list.filter((i) => i.payType !== PayType.balance);
        setPayConfigList(list);
        let payTypes = list.map((i: PayTypeConfig) => i.payType!);
        if (payTypes.length && !payType) {
          setPayType(payTypes[0]);
        }
      }
    } catch (e) {}
  }

  async function loadPayConfigReduction() {
    try {
      let res = await apiGetPayConfigReduction(main.currentEm!.id!);
      let data = res.data;
      if (data.code === 200) {
        let _map: any = {};
        (data.data ?? []).forEach((i: any) => (_map[i.payType] = i));
        setReduction(_map);
      }
    } catch (e) {}
  }

  async function loadActivity() {
    if (!main.currentEm?.id) {
      navigate(-1);
      return;
    }
    LoadingMask.show('正在加载...');
    try {
      let res = await apiGetFirstActivityList(main.currentEm?.id!);
      let data = res.data;
      if (data.code === 200) {
        let _data = data.data;
        let _list: ChargeFirstCoupon[] = [];
        if (_data.payDetails) {
          _data.payDetails.forEach((i: any) => {
            _list.push(Object.assign({}, i, { amount: modelParsePrice(i.amount), price: modelParsePrice(i.price) }));
          });
        }
        setActivity(Object.assign({}, _data, { payDetails: _list }));
      } else {
        showToast(data.msg ?? '获取活动失败,请重试');
        navigate(-1);
      }
    } catch (e: any) {
      showToast(e.message ?? '获取活动失败,请重试');
      navigate(-1);
    } finally {
      LoadingMask.hide();
    }
  }

  async function handleBuy(item: ChargeFirstCoupon) {
    if (!main.openId) {
      return showToast('授权失败,请在微信内打开');
    }
    let _payType = await showBottom((onOk) => (
      <ActivityPaySheet payType={payType} payTypeList={payConfigList} reduction={reduction} onOk={onOk} />
    ));
    if (!_payType) return;
    try {
      LoadingMask.show('正在参与...');
      let res = await apiCreateFirstActivityOrder(main.currentEm!.id!, item.payDetailId!);
      let data = res.data;
      if (data.code === 200) {
        let orderId = data.data.orderId;
        if (orderId) {
          let payRes = await apiPayFirstActivityOrder(orderId, _payType, main.openId!, main.appId!);
          let payData = payRes.data;
          if (payData.code === 200) {
            let _data = payData.data;
            if (_payType === PayType.aliPage) {
              let payRes = await showPayPage(_data, _payType);
              if (payRes.code === 300) {
                if (payRes.url) {
                  LoadingMask.hide();
                  window.location.href = payRes.url;
                  await showConfirm({
                    title: '提示',
                    content: '是否支付完成?',
                    confirmBtnText: '支付完成',
                    cancelBtnText: '未完成',
                  });
                  navigate('/home', { replace: true });
                  showToast('支付成功');
                }
                showToast(payRes.msg);
              } else if (payRes.code === 500) {
                showToast(payRes.msg);
              } else {
                showToast('数据还在准备,请稍后重试');
              }
            } else if (payType === PayType.jsd_mini_wx) {
              // 金舜达 银盛支付 小程序支付  需要弹窗让用户再次点击按钮
              LoadingMask.hide();
              let res = await showJSDConfirmPayDialog({
                miniOrgId: data.data.miniOrgId,
                miniPath: data.data.miniPath,
                miliPaLink: data.data.miniPayLink,
              });
              if (res === 2) {
                showToast('小程序跳转失败');
              } else if (res === 1) {
                let payRes = await showConfirm({
                  title: '提示',
                  content: '是否支付完成?',
                  confirmBtnText: '支付完成',
                  cancelBtnText: '未完成',
                });
                if (!payRes) return;
                navigate('/home', { replace: true });
              } else {
                showToast('取消支付');
              }
            } else {
              if (wxReady) {
                let payRes = await showPayPage(_data, _payType);
                if (payRes.code === 200) {
                  showToast('参与成功');
                  navigate(-1);
                } else if (payRes.code === 300) {
                  if (payRes.url) {
                    LoadingMask.hide();
                    navigate('/iframe', { state: { url: payRes.url, title: '银联支付', pay: true, back: true } });
                  }
                } else if (payRes.code === 500) {
                  showToast(payRes.msg);
                }
              } else {
                showToast('数据还在准备,请稍后重试');
              }
            }
          } else {
            showToast(data.msg ?? '参与失败');
          }
        }
      } else {
        showToast(data.msg ?? '参与失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '参与失败');
    } finally {
      LoadingMask.hide();
    }
  }

  if (!activity) {
    return (
      <Page appBar={<AppBar title="首充活动" />}>
        <NoData isPage tips="正在加载..." />
      </Page>
    );
  }

  return (
    <div className="pos-r bg-white">
      <img className="w-375 pos-a z-0 l-0 t-0" src={activity?.activeImg} alt="" />
      <Page
        className="d-flex-c pos-r z-10 activity-page"
        contentClassName="flex-1 h-1 d-flex-c overflow-hidden"
        appBar={<AppBar title="首充活动" className="bg-gray-t2" showBack={activity?.forceActivity !== 'Y'} />}
      >
        <div className="mt-240 flex-1 h-1 overflow-y">
          <div className="d-shadow m-20 p-10 bg-white border-radius-8">
            <div className="d-flex-r ai-center">
              <div className="title-dot"></div>
              <div className="font-widget-600 font-size-16">官方正品/套餐优惠/随用随充</div>
            </div>
            {(activity?.payDetails ?? []).map((i, index) => (
              <div className="coupon-item" key={index} onClick={() => handleBuy(i)}>
                <div className="item-left">
                  <div className="item-top-num">已有2235人参与</div>
                  <div className="item-price">
                    充<p className="item-price-num">{i.amount}</p>得
                    <p className="item-price-num font-size">{i.price}</p>元
                  </div>
                </div>
                <div className="item-right">
                  <p className="item-right-btn">立即参加活动</p>
                </div>
              </div>
            ))}
          </div>
          <div className="font-size-12 text-color-9 m-20 word-wrap">{activity.activeDesc}</div>
          <div className="bg-white d-shadow border-radius-8 m-20 p-10">
            <div className="d-flex-r ai-center">
              <div className="title-dot"></div>
              <div className="font-widget-600 font-size-16">活动详情</div>
            </div>
            <div
              className="font-size-12 line-height-16 mt-20 word-wrap"
              dangerouslySetInnerHTML={{ __html: (activity.activeDetail ?? '').replaceAll('\n', '<br/>') }}
            ></div>
          </div>
        </div>
      </Page>
    </div>
  );
}
